module.exports = __webpack_public_path__ + "images/preview-defalt-new.png";